import React, { useState, useEffect } from "react";
import Pagination from "../../../common/pagination";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import { paginate } from "../../../utils/paginate";
import Table from "./../../../common/table";
import getService from "../../../services/getService";
import NoImage from "../../../assets/images/NoImage.png";
import deleteService from "../../../services/deleteService";
import { toast } from "react-toastify";
import Delete from "./../../../common/delete";
import { CSVLink } from "react-csv";
import SearchBox from "./../../../common/searchBox";

const SupSubCategoriesTable = () => {
  const [supsubcategories, setSupSubCategory] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [id, setId] = useState(null);

  const fetchSupSubCategory = async () => {
    const supsubcategory = await getService.handleSuperSubCategoryList();
    const filter = supsubcategory.filter((f) => f.title !== null);
    setSupSubCategory(filter);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setCurrentPage(1);
  };

  const handleDelete = async (id) => {
    try {
      await deleteService.DeleteSupSubCategory({ id });
      setCurrentPage(1);
      fetchSupSubCategory();
    } catch (error) {
      toast.error(error);
    }
    setId(null);
  };

  const getPagedData = () => {
    let filtered = supsubcategories;
    if (searchQuery)
      filtered = supsubcategories.filter((m) =>
        m.title.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
    else filtered = supsubcategories;

    const supsubcategory = paginate(filtered, currentPage, pageSize);
    return { totalCount: supsubcategories.length, data: supsubcategory };
  };

  const { length: count } = supsubcategories;

  const { totalCount, data: supsubcategory } = getPagedData();

  const columns = [
    {
      key: "",
      label: "S.No",
      content: (supsubcategory) => (
        <p>{supsubcategories.indexOf(supsubcategory) + 1}</p>
      ),
    },
    { path: "title", label: "Title" },
    // {
    //   path: "logo",
    //   label: "Logo",
    //   content: (c) => (
    //     <>
    //       {c.catpic !== null ? (
    //         <img
    //           style={{ width: "100px", height: "100px" }}
    //           src={c.catpic}
    //           alt="Onclq.com"
    //         />
    //       ) : (
    //         <img
    //           style={{ width: "100px", height: "100px" }}
    //           src={NoImage}
    //           alt="Onclq.com"
    //         />
    //       )}
    //     </>
    //   ),
    // },

    {
      key: "Action",
      label: "Action",
      content: (supsubcategory) => (
        <>
          <button
            class="btn btn-info btn-xs m-b-5 custom_btn"
            onClick={() => {
              navigate(`/admin/supsubcategoriesform/${supsubcategory.id}`);
            }}
          >
            <i class="pe-7s-note" aria-hidden="true"></i>
          </button>
          <Delete
            id={id}
            ItemId={supsubcategory.id}
            setId={setId}
            onClick={handleDelete}
          />
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchSupSubCategory();
  }, []);

  if (count === 0) return <p>There are no orders in the database.</p>;

  return (
    <>
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-bd lobidrag">
            <div class="panel-heading">
              <div class="panel-title">
                <h4>Super Sub Categories List </h4>
              </div>
              <CSVLink
                data={supsubcategories}
                className="btn btn-outline-success"
              >
                Download Report
              </CSVLink>
            </div>
            <div class="row">
              <div class="col-sm-7">
                <SearchBox value={searchQuery} onChange={handleSearch} />
              </div>
            </div>

            <div class="panel-body">
              <Table columns={columns} data={supsubcategory} />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-5">
          <div
            class="dataTables_info"
            id="supplierList_info"
            role="status"
            aria-live="polite"
          >
            Showing {totalCount} entries in the Database
          </div>
        </div>
        <div class="col-sm-7">
          <Pagination
            itemsCount={totalCount}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default SupSubCategoriesTable;
